var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ver_detalle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_222",
    "data-name": "Rect\\xE1ngulo 222",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_33",
    "data-name": "Enmascarar grupo 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    "data-name": "Grupo 134",
    transform: "translate(2.43 5.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_301",
    "data-name": "Trazado 301",
    d: "M15.141,4.763v.1a.078.078,0,0,0-.013.025.521.521,0,0,1-.12.274c-.112.144-.226.286-.341.427a8.869,8.869,0,0,1-.608.68c-.281.28-.563.559-.853.829a10.325,10.325,0,0,1-1.064.862,11.146,11.146,0,0,1-1.036.669,8.9,8.9,0,0,1-1.154.551,7.593,7.593,0,0,1-.971.3,6.188,6.188,0,0,1-1.187.164A5.242,5.242,0,0,1,6.7,9.581c-.237-.041-.474-.088-.707-.148A7.4,7.4,0,0,1,4.55,8.9,10.857,10.857,0,0,1,2.862,7.861a11.319,11.319,0,0,1-1-.825c-.286-.269-.568-.544-.84-.827a11.013,11.013,0,0,1-.79-.918c-.064-.084-.122-.172-.18-.261A.186.186,0,0,1,.026,4.89a.2.2,0,0,0,0-.039L0,4.911V4.733l.014.042A.338.338,0,0,1,.065,4.6a3.115,3.115,0,0,1,.2-.284C.5,4.038.727,3.762.972,3.5A14.007,14.007,0,0,1,2.5,2.069,13.062,13.062,0,0,1,3.569,1.3,10.27,10.27,0,0,1,4.666.69a7.43,7.43,0,0,1,1.5-.525A6.019,6.019,0,0,1,7.384,0a5.656,5.656,0,0,1,.881.038A6.709,6.709,0,0,1,9.2.223,7.012,7.012,0,0,1,10.269.6c.261.118.517.247.769.384a10.444,10.444,0,0,1,1.319.861,11.578,11.578,0,0,1,.906.753q.4.374.785.767a11.674,11.674,0,0,1,.916,1.063.57.57,0,0,1,.16.349l.017-.014m-14,.057a.094.094,0,0,0,.007.014c.286.347.594.675.909,1,.257.262.533.5.809.746a9.93,9.93,0,0,0,1.145.86,8.164,8.164,0,0,0,1.076.606,7.585,7.585,0,0,0,.979.379,5.306,5.306,0,0,0,1.173.216,5.13,5.13,0,0,0,1.435-.108,6.338,6.338,0,0,0,.988-.31c.2-.082.4-.175.6-.274a8.7,8.7,0,0,0,.9-.521,9.131,9.131,0,0,0,.974-.725c.249-.217.5-.431.741-.656a12.675,12.675,0,0,0,.955-1.014l.178-.206-.173-.2A14.117,14.117,0,0,0,12.65,3.4a13.106,13.106,0,0,0-1.164-.945A9.073,9.073,0,0,0,10.051,1.6,7.357,7.357,0,0,0,9,1.2,5.264,5.264,0,0,0,7.89,1.007a4.651,4.651,0,0,0-.977.032c-.2.029-.4.07-.6.118a6.038,6.038,0,0,0-1.078.374,9.472,9.472,0,0,0-1.242.68,9.686,9.686,0,0,0-.978.727,12.172,12.172,0,0,0-.94.85c-.285.3-.557.606-.834.91-.036.04-.07.082-.1.122",
    transform: "translate(0 0)",
    fill: "#b1cb79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_302",
    "data-name": "Trazado 302",
    d: "M160.839,64.905a2.992,2.992,0,1,1-2.968-3,2.995,2.995,0,0,1,2.968,3m-1-.016A2,2,0,1,0,157.85,66.9a1.994,1.994,0,0,0,1.991-2.009",
    transform: "translate(-150.276 -60.078)",
    fill: "#b1cb79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewDetails);
export default __webpack_public_path__ + "static/media/icon_view_details.f0e2ccb57667582778823b9973034138.svg";
export { ForwardRef as ReactComponent };